"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const redux_form_1 = require("redux-form");
const apiActions = __importStar(require("api-actions"));
const utils_1 = require("utils");
const reducer_1 = require("../../../../reducer");
const useActivityTable_1 = __importDefault(require("./_hooks/useActivityTable"));
const useSalesTable_1 = __importDefault(require("./_hooks/useSalesTable"));
const TableAppActivity_1 = __importDefault(require("./TableAppActivity"));
const TableNextDayPend_1 = __importDefault(require("./TableNextDayPend"));
const TableSchedPend_1 = __importDefault(require("./TableSchedPend"));
function DashboardTables({ currentPermissions, currentLocation, applicationStatus, }) {
    // Hook - Sales
    const { displayedNextDayTransactions, displayedPendingTransactions, handleNextDayFilter, handlePendingTransactionFilter, footerTotalNextDayPend, footerTotalSchedPend, salesReportError, salesReportLoading, } = (0, useSalesTable_1.default)({
        locationId: currentLocation?.locationId,
    });
    // Hook - Activity
    const { applicationReports, isActivityTableAccessible, applications, applicationReportError, handleActivityFilter, startDate, endDate, } = (0, useActivityTable_1.default)({
        locationId: currentLocation?.locationId,
        currentPermissions,
        applicationStatus,
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TableNextDayPend_1.default, { tableData: displayedNextDayTransactions, footerTotal: footerTotalNextDayPend ? footerTotalNextDayPend : '', salesReportError: salesReportError, handleTableFilter: handleNextDayFilter, salesReportLoading: salesReportLoading }), (0, jsx_runtime_1.jsx)(TableSchedPend_1.default, { tableData: displayedPendingTransactions, footerTotal: footerTotalSchedPend ? footerTotalSchedPend : '', salesReportError: salesReportError, handleTableFilter: handlePendingTransactionFilter, salesReportLoading: salesReportLoading }), (0, jsx_runtime_1.jsx)(TableAppActivity_1.default, { applicationStatus: applicationStatus, applicationReports: applicationReports, applicationReportError: applicationReportError, applications: applications, handleActivityFilter: handleActivityFilter, startDate: startDate, endDate: endDate, isActivityTableAccessible: isActivityTableAccessible })] }));
}
const selector = (0, redux_form_1.formValueSelector)('activityFilterForm');
function mapStateToProps(state) {
    return {
        applicationStatus: selector(state, 'applicationStatus'),
        searchField: selector(state, 'searchField'),
        applicationReports: reducer_1.selectors.applicationReports(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
        currentPermissions: reducer_1.selectors.currentPermissions(state),
        salesReports: reducer_1.selectors.salesReports(state),
    };
}
const mapApiAuthToProps = {
    fetchAllLocationsForManager: apiActions.fetchAllLocationsForManager,
    getProposedEnrollmentDataChanges: apiActions.getProposedEnrollmentDataChanges,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(DashboardTables);
